{
  "Announcements": "Ankündigungen",
  "MarkAllAsRead": "Alle als gelesen markieren",
  "NoLinkNotification": "Kein Link verfügbar für diese Benachrichtigung",
  "Notification": "Benachrichtigungen",
  "ViewAll": "Alle anzeigen"
}
